module Easypass {
    class InfosSiteController extends Core.InfosSiteController {
        roomService: boolean = false;
    }
    angular.module('easypass').controller('infosSiteController', ['userService', 'restaurantsService', 'storageService', "$rootScope", "$scope", InfosSiteController]);
}